document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-scroll]').forEach(el=>{el.addEventListener('click',e=>{const id=el.getAttribute('href');if(id&&id.startsWith('#')){const target=document.querySelector(id);if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth'});}}});});});

/* Proper Shopify/Appstle checkout routing */
document.addEventListener('DOMContentLoaded', function () {
  var forms = document.querySelectorAll('.proper-checkout-form');
  if (!forms.length) return;

  forms.forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = true;
      }

      var data = new FormData(form);

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      })
    .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          body: data,
          headers: { 'Accept': 'application/json' }
        });
      })
    .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed.');
        return response.json();
      })
    .then(function () {
        window.location.href = '/checkout';
      })
    .catch(function () {
        form.submit();
      });
    });
  });
});

/* Bottom ritual CTA subscription checkout */
document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('BottomRitualSubscriptionCheckoutForm');
  if (!form) return;

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    if (button) {
      button.disabled = true;
      button.textContent = 'Taking you to checkout...';
    }

    var data = new FormData(form);

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' }
    })
  .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' }
      });
    })
  .then(function (response) {
      if (!response.ok) throw new Error('Subscription add failed.');
      return response.json();
    })
  .then(function () {
      window.location.href = '/checkout';
    })
  .catch(function () {
      form.submit();
    });
  });
});

/* NEURAWSOM hide Appstle product widget while keeping portal available */
document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/products/')) return;

  function hideAppstleProductWidgets() {
    var selectors = [
      '.appstle_subscription_widget',
      '.appstle_sub_widget',
      '.appstle_widget',
      '.appstle_widget_container',
      '.appstle_product_page_widget',
      '.appstle_subscription_wrapper',
      '.appstle_subscribe_save_wrapper',
      '.appstle_widget_wrapper',
      '[class*="appstle"][class*="widget"]',
      '[id*="appstle"][id*="widget"]'
    ];

    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        if (el.id === 'appstle-subscription-manage-subscription-button-placeholder') return;
        el.style.display = 'none';
        el.style.visibility = 'hidden';
        el.style.height = '0';
        el.style.minHeight = '0';
        el.style.margin = '0';
        el.style.padding = '0';
        el.style.overflow = 'hidden';
      });
    });
  }

  hideAppstleProductWidgets();
  setTimeout(hideAppstleProductWidgets, 500);
  setTimeout(hideAppstleProductWidgets, 1500);
});


/* Bottom Ritual subscription checkout */
document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('BottomRitualSubscriptionCheckoutForm');
  if (!form) return;

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    if (button) {
      button.disabled = true;
      button.textContent = 'Taking you to checkout...';
    }

    var data = new FormData(form);

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' }
    })
    .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' }
      });
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Subscription add failed.');
      return response.json();
    })
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function () {
      form.submit();
    });
  });
});
